<template>
    <div class="card cart-card shadow-sm">
        <div class="card-header">
            <span class="icon map-icon pr-2"></span>
            <span class="align-text-bottom">
                {{ $t('taxi.components.cart.header') }}
            </span>
        </div>

        <div class="px-3 py-2 text-sm text-muted" v-if="!travel">
            {{ $t('taxi.components.cart.no_travel') }}
        </div>

        <template v-else>
            <cart-travel
                :label="$t('taxi.components.cart.departure')"
                :departure-date="search.departure_date"
                :departure-time="search.departure_time"
                :start-place="search.start_place"
                :end-place="search.end_place"
                :travel="travel"
            />

            <div class="bg-body border-top p-3 text-blue-600">
                <div class="d-flex align-items-center justify-content-between text-sm" v-if="discount">
                    <div>
                        {{ $t('taxi.components.cart.base_price') }}:
                    </div>

                    <div class="font-weight-bold">
                        {{ formatPrice(cartBaseTotal, travel.currency) }}
                    </div>
                </div>

                <div class="d-flex align-items-center justify-content-between text-sm mb-2" v-if="discount">
                    <div>
                        {{ $t('taxi.components.cart.discount_value') }}:
                    </div>

                    <div class="font-weight-bold">
                        &ndash;&nbsp;{{ formatPrice(cartDiscountValue, travel.currency) }}
                    </div>
                </div>

                <div class="d-flex align-items-center justify-content-between text-sm mb-2" v-if="userDiscountValue">
                    <div>
                        {{ $t('taxi.components.cart.user_discount_value') }}:
                    </div>

                    <div class="font-weight-bold">
                        &ndash;&nbsp;{{ formatPrice(userDiscountValue, travel.currency) }}
                    </div>
                </div>

                <div class="d-flex align-items-center justify-content-between font-weight-bold">
                    <div>
                        {{ $t('total') }}:
                    </div>

                    <div class="text-lg">
                        {{ formatPrice(cartTotal, travel.currency) }}

                        <div v-if="travel.currency === 'eur'">
                            {{ formatPrice(cartTotal * eurToPln, 'pln') }}
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';

    import CartTravel from './CartTravel';

    export default {
        components: {
            CartTravel,
        },

        computed: {
            ...mapGetters({
                search: 'berbus/search',
                travel: 'berbus/getTravel',
                discount: 'berbus/getDiscount',
                cartBaseTotal: 'berbus/getCartBaseTotal',
                cartDiscountValue: 'berbus/getCartDiscountGrossValue',
                cartTotal: 'berbus/getCartTotal',
                eurToPln: 'constants/eurToPln',
                userDiscountValue: 'berbus/getUserDiscountGrossValue',
            }),
        },
    };
</script>
